import {IgnoreError} from "../shared/sharedFunctions";
import {handleServiceRequest} from "./handleServiceRequest";

export const estimateService = {
    searchEstimates(searchKeywords: string[], statusType: string, startingPage: number, pageSize: number, sortField: string, orderByDesc: boolean) {
        const object = {
            url: `${baseUrl}/incomplete/search`,
            postBody: {
                startingPage: startingPage < 0 ? 0 : startingPage,
                count: pageSize,
                searchWords: searchKeywords,
                estimatorUserId: null,
                sortByField: sortField,
                orderByDesc: orderByDesc,
                statusType: statusType ? statusType : null
            },
            customErrorMessage: `Failed to get estimate list`,
        };
        return handleServiceRequest.post(object);
    },
    getEstimateTotalForSidebar() {
        const object = {
            url: `${baseUrl}/incomplete/count`,
            customHandleError: IgnoreError
        };
        return handleServiceRequest.get(object);
    },
    claimEstimate(jobId) {
        const object = {
            url: `${baseUrl}/claim`,
            postBody: {
                jobIds: [jobId]
            },
            customErrorMessage: `Failed to claim estimate`,
            
        };
        return handleServiceRequest.post(object);
    },
    approveEstimate(jobId, postObj) {
        const object = {
            url: `${baseUrl}/approve/${jobId}`,
            postBody: postObj,
            customErrorMessage: `Failed to approve estimate`,
        };
        return handleServiceRequest.put(object);
    },
    previewEstimate(jobId: number, postObj: any) {
        const object = {
            url: `${baseUrl}/preview/${jobId}`,
            postBody: postObj,
            customErrorMessage: `Failed to load estimate preview`,
        };
        return handleServiceRequest.post(object);
    },
};
const baseUrl = `/api/estimates`;